export const CONFIG = {
    API: {
        TIMEOUT: 1000000, // Changing this time for FLN-20979
    },
    AUTH: {
        LICENSE_TYPE: 'license-type',
        TOKEN_KEY: 'auth_token',
        CURRENT_PROJECT: 'current-project',
        REFRESH_TOKEN_KEY: 'refresh_token',
        SESSION_TIMEOUT: 3600,
        TEST_OPTIMIZE_USER: 'test-optimize-user',
        CURRENT_LICENSE_ID: 'currentLicenseId',
    },
    CACHE: {
        TTL: 300, // 5 minutes in seconds
        MAX_SIZE: 100, // Maximum number of cached items
    },
};
//# sourceMappingURL=baseConfig.js.map